import { Grid } from '@material-ui/core';

export default class extends React.PureComponent {
	render() {
		return <Grid {...this.props} />
	}
}